/**
 * 前端常量定义
 */
(function (definition) {
    var hasDefine = typeof define == 'function',
        hasExports = typeof module != 'undefined' && module.exports;
    if (hasDefine) {
        define('core/view-constant', function (require, exports, module) {
            module.exports = definition()
        })
    } else if (hasExports) {
        module.exports = definition()
    } else {
        this['core/view-constant'] = definition()
    }
})(function () {
    var PortraitUrl = 'https://101test-public.oss-cn-beijing.aliyuncs.com/common/employer/defaultPortrait/{index}.png';

    var StoreType = {
        PAPER: 0,
        BANK: 1
    };

    /*
     * 页面视图状态定义
     */
    var ViewState = {
        DEFAULT: 0, // 默认展现，无额外操作
        RENDER: 1, // 同上
        CREATE: 2, // 创建模式
        EDIT: 3, // 编辑模式
        EXECUTE: 4, // 执行模式
        DELETE: 5
        // 删除模式
    };

    var SupportFormat = {
        video: 'flv,f4v,mp4',
        audio: 'flv,f4v,mp4,mp3'
    };
    var HeadMenuItems = {
        HOME: {value: 'a', tag: '首页', href: ''},
        PAPER: {value: 'b', tag: '考试', href: 'paper'},
        SCORE: {value: 'c', tag: '成绩', href: 'my-test'},
        CLASS: {value: 'd', tag: '群组', href: 'group'},
        BANK: {value: 'e', tag: '题库', href: 'bank'},
        HELP: {value: 'f', tag: '服务说明', href: 'help/open/index'},
        STORE: {value: 'g', tag: '资源', href: 'store/open/resource'}
    };
    var HeadMenuItemsKey = {
        a: 'HOME',
        b: 'PAPER',
        c: 'SCORE',
        d: 'CLASS',
        e: 'BANK',
        f: 'HELP',
        g: 'STORE'
    }
    var BankViewType = {
        STAT: 'statistic',
        ORDINARY: 'ordinary'
    }
    /**
     * 动画执行完毕触发事件名称
     */
    var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

    var transitionEnd = function () {
        var el = document.createElement('bootstrap');

        var transEndEventNames = {
            WebkitTransition: 'webkitTransitionEnd',
            MozTransition: 'transitionend',
            OTransition: 'oTransitionEnd otransitionend',
            transition: 'transitionend'
        };

        for (var name in transEndEventNames) {
            if (el.style[name] !== undefined) {
                return {
                    end: transEndEventNames[name]
                }
            }
        }
        return false; // explicit for ie8 (  ._.)
    };

    var CodeMirrorModeMapping = {
        JAVA: {
            mode: 'text/x-java',
            intent: true
        },
        C: {
            mode: 'text/x-csrc',
            intent: true
        },
        CPP: {
            mode: 'text/x-c++src',
            intent: true
        },
        OBJECTIVE_C: {
            mode: 'text/x-objectivec',
            intent: true
        },
        PYTHON: {
            mode: {
                name: "python",
                version: 3,
                singleLineStringErrors: false
            },
            intent: false
        },
        SHELL: {
            mode: 'shell',
            intent: true
        },
        JAVASCRIPT: {
            mode: 'text/javascript',
            intent: true
        },
        PHP: {
            mode: 'application/x-httpd-php',
            intent: true
        },
        PERL: {
            mode: 'text/x-perl',
            intent: true
        },
        RUBY: {
            mode: 'text/x-ruby',
            intent: true
        },
        C_SHARP: {
            mode: 'text/x-csharp',
            intent: true,
        },
        SQL: {
            mode: 'text/x-mariadb',
            intent: true
        },
        WEB: {
            mode: 'text/html',
            intent: true
        },
        OTHER: {
            mode: 'text/plain',
            intent: false
        }
    }

    var questionTypeOrder = [
        'SCQ', // 单选题
        'MCQS', // 多选题
        'MCQ', // 不定项
        'SCQ_TEXT', // 单选问答题
        'MCQS_TEXT', // 多选问答题
        'MCQ_TEXT', // 不定项问答
        'SCQ_U', // 非确定单选
        'BCQ', // 判断题
        'BLANK', // 填空题
        'COMBINATION', // 组合题
        'TEXT', // 问答题
        'AUDIO', // 音频题
        'VIDEO', // 视频题
        'PROGRAM' // 编程题
    ]

    var companyForCert = {
        FACI: 15777
    }

    var captureObj = {
        url: 'account/open/createCaptcha'
    }

    return {
        PortraitUrl: PortraitUrl,
        ViewState: ViewState,
        BankViewType: BankViewType,
        StoreType: StoreType,
        animationEnd: animationEnd,
        SupportFormat: SupportFormat,
        transitionEnd: transitionEnd,
        HeadMenuItems: HeadMenuItems,
        HeadMenuItemsKey: HeadMenuItemsKey,
        CodeMirrorModeMapping: CodeMirrorModeMapping,
        questionTypeOrder: questionTypeOrder,
        companyForCert: companyForCert,
        captureObj: captureObj
    };
})


// WEBPACK FOOTER //
// ./core/view-constant.js